import React from "react";
import PropTypes from "prop-types";
import { textContentPropType } from "../../lib/dataShapes";
import TextContent from "./TextContent";
import styles from "../../styles/contentBox.module.scss";

const HeaderContentBox = ({ title, content }) => (
  <div className={styles.contentBoxWithHeader}>
    <h2>{title}</h2>
    <div className={styles.contentBoxWithHeaderContent}>
      <TextContent content={content} />
    </div>
  </div>
);

HeaderContentBox.propTypes = {
  title: PropTypes.string.isRequired,
  content: textContentPropType
};

export default HeaderContentBox;
